<template>
  <div class="d-block" v-if="modalShow">
    <v-dialog
      v-model="modalShow"
      class="registerModal"
      ref="registerModal"
      hide-header
      hide-footer
      centered
      body-class="p-0"
      scroll-strategy="none"
      :fullscreen="lineLayout.includes('Minimal')"
      :hide-overlay="lineLayout.includes('Minimal')"
      :transition="
        lineLayout.includes('Minimal') ? 'slide-up-down' : 'fade-transition'
      "
    >
      <WelcomeScreenMinimalTheme @close="close" />
    </v-dialog>
  </div>
  <WelcomeImagePopup ref="image-popup" :form="detail" />
</template>

<script>
import WelcomeScreenMinimalTheme from "@/components/profile/modal/WelcomeScreenMinimalTheme";
import WelcomeImagePopup from "@/components/profile/modal/WelcomePopup";
export default {
  components: { WelcomeScreenMinimalTheme, WelcomeImagePopup },
  props: {},
  data() {
    return {
      modalShow: false,
      lineProfile: {
        displayName: ""
      },
      detail: []
    };
  },

  methods: {
    async show() {
      await this.getWelcome();

      if (
        this.$cookies.get("popupModalRegister") == "true" &&
        (this.$config.welcome_screen_active == 1 || this.detail.is_active == 1)
      ) {
        if (!this.lineLayout.includes("Minimal") || this.$isCleanLayout) {
          this.$refs["image-popup"].show();
        } else {
          this.modalShow = true;
          this.lineProfile = this.$cookies.get("user_profile_token");
        }
      } else this.$cookies.set("popupModalRegister", false);
    },
    close() {
      if (this.lineLayout.includes("Minimal")) {
        this.modalShow = false;
        this.$refs["image-popup"].show();
      } else {
        this.modalShow = false;
        this.$cookies.set("popupModalRegister", false);
      }
    },
    async getWelcome() {
      const res = await this.$axios("/api/v1/setting/welcomescreen/popup");
      this.detail = res.detail;
    }
  }
};
</script>

<style lang="scss" scoped>
.modal-body {
  margin: auto;
  text-align: center;
}
.image-logo {
  width: 100%;
  height: 100%;
}
</style>
